function debounce(func, wait, immediate) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func(...args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func(...args);
  };
}

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
class ProductCard extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("click", (event) => {
      if (
        event.target.closest(".addcart_btn") ||
        event.target.closest(".addcompare_btn")
      ) {
        return;
      }
      window.location.href = this.dataset.productUrl;
    });
  }
}
customElements.define("product-card", ProductCard);

class PriceSlider extends HTMLElement {
  constructor() {
    super();
    this.priceSlider = null;
    this.minInput = null;
    this.maxInput = null;
    this.hiddenMinInput = null;
    this.hiddenMaxInput = null;
    this.rangeText = null;
    this.rangeMin = 0;
    this.rangeMax = 0;
    this.currentMin = 0;
    this.currentMax = 0;
    this.updateTimeout = null;
    this.lastSubmittedMin = 0;
    this.lastSubmittedMax = 0;
    this.formEventListener = null;
    this.isInitialized = false;
    this.debouncedHandleInputChange = debounce(
      this.handleInputChange.bind(this),
      300
    );
    this.debouncedUpdateHiddenInputs = debounce(
      this.updateHiddenInputs.bind(this),
      500
    );
    this.debouncedFormUpdate = debounce(
      this.dispatchFormUpdate.bind(this),
      1000
    );
  }

  connectedCallback() {
    if (this.isInitialized) {
      return;
    }

    this.priceSlider = this.querySelector(".filter-price-sliderr");
    this.minInput = this.querySelector(".price-input.min-price");
    this.maxInput = this.querySelector(".price-input.max-price");
    this.hiddenMinInput = this.querySelector(".filter-price--min");
    this.hiddenMaxInput = this.querySelector(".filter-price--max");
    this.rangeText = this.querySelector(".filter-price-range");

    if (
      !this.priceSlider ||
      !this.minInput ||
      !this.maxInput ||
      !this.hiddenMinInput ||
      !this.hiddenMaxInput
    ) {
      console.warn("PriceSlider: Required elements not found");
      return;
    }

    this.rangeMin = parseFloat(this.priceSlider.dataset.rangemin) || 0;
    this.rangeMax = parseFloat(this.priceSlider.dataset.rangemax) || 1000;

    this.currentMin = this.minInput.value
      ? Math.max(this.rangeMin, parseFloat(this.minInput.value))
      : this.rangeMin;
    this.currentMax = this.maxInput.value
      ? Math.min(this.rangeMax, parseFloat(this.maxInput.value))
      : this.rangeMax;

    if (this.currentMin > this.currentMax) {
      this.currentMin = this.rangeMin;
      this.currentMax = this.rangeMax;
    }

    this.lastSubmittedMin = this.currentMin;
    this.lastSubmittedMax = this.currentMax;

    this.minInput.value = Math.round(this.currentMin);
    this.maxInput.value = Math.round(this.currentMax);
    this.updateRangeText();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.initializeSlider();
      });
    } else {
      this.initializeSlider();
    }

    this.setupEventListeners();
    this.isInitialized = true;
  }

  initializeSlider() {
    if (this.priceSlider && this.priceSlider.noUiSlider) {
      this.priceSlider.noUiSlider.destroy();
    }
    noUiSlider.create(this.priceSlider, {
      start: [this.currentMin, this.currentMax],
      connect: true,
      step: 1,
      range: {
        min: this.rangeMin,
        max: this.rangeMax,
      },
    });

    this.priceSlider.noUiSlider.on("update", (values, handle) => {
      const newMin = Math.round(values[0]);
      const newMax = Math.round(values[1]);

      if (handle === 0 && newMin !== this.currentMin) {
        this.currentMin = newMin;
        this.minInput.value = this.currentMin;
      } else if (handle === 1 && newMax !== this.currentMax) {
        this.currentMax = newMax;
        this.maxInput.value = this.currentMax;
      }

      this.updateRangeText();
      this.updateHiddenInputs();
    });
  }

  setupEventListeners() {
    this.minInput.addEventListener("change", () => this.handleInputChange());
    this.maxInput.addEventListener("change", () => this.handleInputChange());

    this.minInput.addEventListener("keyup", (e) => {
      if (e.key === "Enter") this.handleInputChange();
    });

    this.maxInput.addEventListener("keyup", (e) => {
      if (e.key === "Enter") this.handleInputChange();
    });

    document
      .querySelector("#CollectionFiltersForm")
      .addEventListener("input", () => {
        this.initializeSlider();
        this.setupEventListeners();
      });
  }

  handleInputChange() {
    let newMin = parseInt(this.minInput.value) || this.rangeMin;
    let newMax = parseInt(this.maxInput.value) || this.rangeMax;

    newMin = Math.max(this.rangeMin, Math.min(newMin, this.rangeMax));
    newMax = Math.min(this.rangeMax, Math.max(newMax, this.rangeMin));

    if (newMin > newMax) {
      if (document.activeElement === this.minInput) {
        newMin = this.currentMin;
        this.minInput.value = this.currentMin;
      } else {
        newMax = this.currentMax;
        this.maxInput.value = this.currentMax;
      }
      return;
    }

    this.currentMin = newMin;
    this.currentMax = newMax;

    if (this.priceSlider.noUiSlider) {
      this.priceSlider.noUiSlider.set([this.currentMin, this.currentMax]);
    }

    this.updateRangeText();
    this.updateHiddenInputs();
  }

  updateRangeText() {
    if (this.rangeText) {
      this.rangeText.textContent = `${this.currentMin} - ${this.currentMax}`;
    }
  }

  updateHiddenInputs() {
    this.hiddenMinInput.value = this.currentMin;
    this.hiddenMaxInput.value = this.currentMax;

    clearTimeout(this.updateTimeout);
    this.updateTimeout = setTimeout(() => {
      if (
        this.currentMin !== this.lastSubmittedMin ||
        this.currentMax !== this.lastSubmittedMax
      ) {
        this.lastSubmittedMin = this.currentMin;
        this.lastSubmittedMax = this.currentMax;
        this.dispatchFormUpdate();
      }
    }, 1000);
  }

  dispatchFormUpdate() {
    const event = new Event("input", {
      bubbles: true,
      cancelable: true,
    });
    const form = this.closest("form");
    if (form) {
      form.dispatchEvent(event);
    }
  }

  disconnectedCallback() {
    if (this.priceSlider && this.priceSlider.noUiSlider) {
      this.priceSlider.noUiSlider.destroy();
    }
  }
}

customElements.define("price-slider", PriceSlider);

class RateProduct extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.maxRating = parseFloat(this.dataset.maxRating) || 1;
    this.swiperInstance = null;
    this.topSliderItems = this.querySelectorAll(
      ".cstm-rate-product--slider-item"
    );
    this.cardsItems = this.querySelectorAll(
      ".cstm-rate-product--card-content--right"
    );
    this.currentRatings = {};
  }

  connectedCallback() {
    this.topSliderItems.forEach((item) => {
      const title = item.dataset.title;
      const rangeElement = item.querySelector('.cstm-rate-product--slider-item-range');
      if (rangeElement) {
        const currentWidth = parseFloat(rangeElement.style.getPropertyValue('--width-rating')) || 0;
        this.currentRatings[title] = (currentWidth * this.maxRating) / 100;
      } else {
        this.currentRatings[title] = 0;
      }
    });

    this.topSliderItems.forEach((item) => {
      item.addEventListener("click", () => {
        this.voteUpdate(item.dataset.title, `top_slider${!item.dataset.type ? '' : item.dataset.type}`, item);
      });
    });
    this.cardsItems.forEach((item) => {
      item.addEventListener("click", () => {
        this.voteUpdate(item.dataset.title, `cards${!item.dataset.type ? '' : item.dataset.type}`, item);
      });
    });
    document.addEventListener("DOMContentLoaded", () => {
      this.initSwiper();
    });
  }

  initSwiper() {
    const swiperContainer = this.querySelector(".swiper");
    if (!swiperContainer) {
      console.warn("Swiper container not found in rate-product component");
      return;
    }

    try {
      this.swiperInstance = new Swiper(swiperContainer, {
        spaceBetween: 20,
        freeMode: true,
        slidesPerView: 3.9,
        spaceBetween: 10,
        breakpoints: {
          500: {
            slidesPerView: 5.7,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 7.3,
            spaceBetween: 10,
          },
          1100: {
            slidesPerView: 10,
            spaceBetween: 10,
          },
        },
      });
    } catch (error) {
      console.error("Error initializing Swiper for rate-product:", error);
    }
  }

  updateRatings(type, key, item) {
    localStorage.setItem(`product_${this.productId}_${type}_${key.toLowerCase().replace(/\s+/g, '_')}_rated`, "true");

    if (type === "top_slider" || type === "top_slider_meta") {
      const currentValue = this.currentRatings[key] || 0;
      const newValue = currentValue + 1;
      this.currentRatings[key] = newValue;
      
      let newMaxRating = 0;
      Object.values(this.currentRatings).forEach(value => {
        const ratingValue = value * 1.2;
        if (ratingValue > newMaxRating) {
          newMaxRating = ratingValue;
        }
      });
      
      if (newMaxRating > 0) {
        this.maxRating = newMaxRating;
      }
      
      this.topSliderItems.forEach((sliderItem) => {
        const title = sliderItem.dataset.title;
        const sliderRangeElement = sliderItem.querySelector('.cstm-rate-product--slider-item-range');
        
        if (sliderRangeElement) {
          const itemValue = this.currentRatings[title] || 0;
          const widthPercentage = (itemValue * 100) / this.maxRating;
          sliderRangeElement.style.setProperty('--width-rating', `${widthPercentage}%`);
        }
      });
    } else if (type === "cards" || type === "cards_meta") {
      const countElement = item.querySelector(".cstm-rate-product--card-count");
      if (countElement) {
        const currentCount = parseInt(countElement.innerHTML) || 0;
        countElement.innerHTML = currentCount + 1;
      }
    }
  }

  voteUpdate(key, type, item) {
    if (localStorage.getItem(`product_${this.productId}_${type}_${key.toLowerCase().replace(/\s+/g, '_')}_rated`)) return;

    this.updateRatings(type, key, item);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      productId: `gid://shopify/Product/${this.productId}`,
      ratingItem: {
        type: type,
        key: key,
        value: 1,
      },
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://nearstore-rating-app.vercel.app/api/rate?Content-Type=application/json",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  }
}
customElements.define("rate-product", RateProduct);

document.addEventListener("DOMContentLoaded", () => {
  let resizeTimeout;

  function updateBackgroundHeight() {
    const bgImage = document.querySelector(".absolute_bg_top");
    if (!bgImage) return;

    const triggerElements = document.querySelectorAll(".triger-bg--js");
    if (!triggerElements.length) return;

    const maxBottomPosition = Math.max(
      ...Array.from(triggerElements).map((el) => {
        const rect = el.getBoundingClientRect();
        return rect.top + window.scrollY + rect.height;
      })
    );

    bgImage.style.height = `${maxBottomPosition}px`;
  }

  function triggerCollectionFiltersOverlay() {
    if (window.innerWidth > 991) return;

    const collectionFiltersDropdown = document.querySelectorAll(
      ".collection-page--filters-drop"
    );
    const header = document.querySelector(".cstm-header");

    if (!collectionFiltersDropdown.length || !header) return;

    collectionFiltersDropdown.forEach((dropdown) => {
      dropdown.addEventListener("click", () => {
        requestAnimationFrame(() => {
          header.style.zIndex = dropdown.open ? "1" : "6";
        });
      });
    });
  }

  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateBackgroundHeight();
      triggerCollectionFiltersOverlay();
    }, 250);
  }

  triggerCollectionFiltersOverlay();
  updateBackgroundHeight();
  window.addEventListener("resize", handleResize);
  window.addEventListener("load", updateBackgroundHeight);
});
